<template>
    <div class="parentx">
        <vs-sidebar v-hammer:swipe.left="onSwipeLeft" ref="mainSidebar" :parent="parent" :hiddenBackground="clickNotClose" :reduce="reduce" default-index="-1" class="sidebarx main-menu-sidebar items-no-padding" v-model="isSidebarActive" :click-not-close="clickNotClose" :reduce-not-rebound="reduceNotRebound">
            <div @mouseenter="sidebarMouseEntered" @mouseleave="sidebarMouseLeave">
                <div class="header-sidebar flex items-end justify-between bg-light" slot="header">
                    <div class="logo flex items-center" style="max-width: 100%;">
                        <img :src="logo" alt="logo" class="w-10 mr-4" v-if="logo" v-show="reduce && !isMouseEnter" style="max-width: 80%">
                        <img :src="logo" alt="logo" class="mr-4" v-if="logo" v-show="isMouseEnter || !reduce" style="max-width: 80%">
                        <!-- <span class="logo-text" v-show="isMouseEnter || !reduce" v-if="title">{{ title }}</span> -->
                    </div>
                    <div style="position: absolute; right: 16px; top:36px;">
                        <template v-if="showCloseButton">
                            <feather-icon icon="XIcon" class="m-0 cursor-pointer" @click="$store.commit('TOGGLE_IS_SIDEBAR_ACTIVE', false)"></feather-icon>
                        </template>
                        <template v-else-if="!showCloseButton && !sidebarItemsMin">
                            <feather-icon icon="DiscIcon" class="mr-0 cursor-pointer" svg-classes="stroke-current" v-show="!reduce" @click="toggleReduce(true)" id="btnSidebarToggler"></feather-icon>
                            <feather-icon icon="CircleIcon" class="mr-0 cursor-pointer" svg-classes="stroke-current" v-show="reduce" @click="toggleReduce(false)" id="btnSidebarToggler"></feather-icon>
                        </template>
                    </div>
                </div>

                <div class="shadow-bottom" v-show="showShadowBottom"></div>

                <VuePerfectScrollbar ref="mainSidebarPs" class="scroll-area--main-sidebar pt-2" :settings="settings" @ps-scroll-y="psSectionScroll">
                    <template v-for="(sidebarItem, index) in finalSidebarItems">
                        <!-- GROUP ITEM HEADER -->
                        <span :key="`header-${index}`" v-if="sidebarItem.header && !sidebarItemsMin" class="navigation-header truncate">{{ $t(sidebarItem.i18n) || sidebarItem.header }}</span>
                        <template v-else-if="!sidebarItem.header">

                            <!-- IF IT'S SINGLE ITEM -->
                            <vx-sidebar-item ref="sidebarLink" :key="`sidebarItem-${index}`" v-if="!sidebarItem.submenu" :index="index" :to="sidebarItem.slug != 'external' ? sidebarItem.url : ''" :href="sidebarItem.slug == 'external' ? sidebarItem.url : ''" :icon="sidebarItem.icon" :target="sidebarItem.target" :isDisabled="sidebarItem.isDisabled" :slug="sidebarItem.slug">
                                <span v-show="!sidebarItemsMin" class="truncate">{{ $t(sidebarItem.i18n) || sidebarItem.name }}</span>
                                <vs-chip class="ml-auto" :color="sidebarItem.tagColor" v-if="sidebarItem.tag && (isMouseEnter || !reduce)">{{ sidebarItem.tag }}</vs-chip>
                            </vx-sidebar-item>

                            <!-- IF HAVE SUBMENU / DROPDOWN -->
                            <template v-else>
                                <vx-sidebar-group ref="sidebarGrp" :key="`group-${index}`" :openHover="openGroupHover" :group="sidebarItem" :groupIndex="index" :open="isGroupActive(sidebarItem)" v-if="canSee(sidebarItem)"></vx-sidebar-group>
                            </template>
                        </template>
                    </template>
                </VuePerfectScrollbar>
            </div>
        </vs-sidebar>
        <div v-hammer:swipe.right="onSwipeRightSidebarSwipeArea" v-if="!isSidebarActive" class="sidebar-swipe-area" id="sidebar-swipe-area"></div>
    </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import VxSidebarGroup from './VxSidebarGroup.vue'
import VxSidebarItem  from './VxSidebarItem.vue'

export default {
    name: 'vx-sidebar',
    props: {
        sidebarItems: {
            type: Array,
            required: true,
        },
        title: {
            type: String,
        },
        logo: {
            type: String
        },
        parent: {
            type: String
        },
        openGroupHover: {
            type: Boolean,
            default: false
        },
        reduceNotRebound: {
            type: Boolean,
            default: true,
        }
    },
    data: () => ({
        clickNotClose: false, // disable close sidebar on outside click
        reduce: false, // determines if sidebar is reduce - component property
        showCloseButton: false, // show close button in smaller devices
        isMouseEnter: false,
        settings: { // perfectscrollbar settings
            maxScrollbarLength: 60,
            wheelSpeed: 1,
            swipeEasing: true
        },
        windowWidth: window.innerWidth, //width of windows
        showShadowBottom: false,
        finalSidebarItems: []
    }),
    computed: {
        isSidebarActive: {
            get() {
                return this.$store.state.isSidebarActive
            },
            set(val) {
              this.$store.commit('TOGGLE_IS_SIDEBAR_ACTIVE', val)
            }
        },
        reduceSidebar() {
            return Boolean(this.reduce && this.reduceButton)
        },
        reduceButton: {
            get() {
                return this.$store.state.reduceButton;
            },
            set(val) {
                this.$store.commit('TOGGLE_REDUCE_BUTTON', val)
            }
        },
        sidebarItemsMin() {
            return this.$store.state.sidebarItemsMin;
        },
        isGroupActive() {
            return (sidebarItem) => {
                const path = this.$route.name;
                const params = this.$route.params;
                let open = false;
                let $this = this
                let func = function(sidebarItem) {
                    if (sidebarItem.submenu) {
                        sidebarItem.submenu.forEach((item) => {
                            if (path == item.url.name && (!params || !item.url.params || $this.isEqual(params, item.url.params))) { open = true }
                            else if (item.submenu) { func(item) }
                        })
                    }
                }
                func(sidebarItem)
                return open
            }
        }
    },
    watch: {
        reduce(val) {

            if (val == true) {
                this.$store.dispatch('updateSidebarWidth', 'reduced');
            } else {
                this.$store.dispatch('updateSidebarWidth', 'default');
            }

            setTimeout(function(){
                window.dispatchEvent(new Event('resize'));
            }, 100);
        },
        reduceButton() {
            this.setSidebarWidth();
        },
        '$route'() {
            if(this.isSidebarActive && this.showCloseButton) this.$store.commit('TOGGLE_IS_SIDEBAR_ACTIVE', false);
        },
        '$store.state.auth.userRole'() {
            this.addStoreMenu()
        },
        '$store.state.organisation.organisation_user'() {
            this.addStoreMenu()
        },
        '$store.state.organisation.dpr_reports': {
            deep: true,
            handler: function () {
                this.addStoreMenu()
            }
        },
        '$store.state.is_online'() {
            this.addStoreMenu()
        }
    },
    methods: {
        sidebarMouseEntered() {
            if (this.reduce) this.$store.commit('UPDATE_SIDEBAR_ITEMS_MIN', false)
            this.isMouseEnter = true;
        },
        sidebarMouseLeave() {
            if (this.reduce) {
                this.$store.commit('UPDATE_SIDEBAR_ITEMS_MIN', true);
            }
            this.isMouseEnter = false;
        },
        toggleReduce(val) {
            this.reduceButton = val;
            this.setSidebarWidth();
        },
        handleWindowResize(event) {
            this.windowWidth = event.currentTarget.innerWidth;
            this.setSidebarWidth();
        },
        setSidebarWidth() {
            if (this.windowWidth < 1200) {
                if(this.windowWidth < 992) this.$store.commit('UPDATE_WINDOW_BREAKPOINT', 'md')
                else this.$store.commit('UPDATE_WINDOW_BREAKPOINT', 'lg')

                this.$store.commit('TOGGLE_IS_SIDEBAR_ACTIVE', false)
                if (this.reduceButton) this.reduce = false;
                // this.reduceButton = false;
                this.showCloseButton = true;
                this.clickNotClose = false;
                this.$store.dispatch('updateSidebarWidth', 'no-sidebar')
                this.$store.commit('UPDATE_SIDEBAR_ITEMS_MIN', false)
            }
            else {
                this.$store.commit('UPDATE_WINDOW_BREAKPOINT', 'xl')
                if (this.reduceButton) this.reduce = true;
                else this.reduce = false;

                this.$store.commit('TOGGLE_IS_SIDEBAR_ACTIVE', true)
                if (this.reduceButton && !this.isMouseEnter) this.$store.commit('UPDATE_SIDEBAR_ITEMS_MIN', true)
                else this.$store.commit('UPDATE_SIDEBAR_ITEMS_MIN', false)

                this.clickNotClose = true;
                this.showCloseButton = false;
                if (this.reduceSidebar)
                    this.$store.dispatch('updateSidebarWidth', 'reduced')
                else
                    this.$store.dispatch('updateSidebarWidth', 'default')
            }
        },
        psSectionScroll() {
            if(this.$refs.mainSidebarPs.$el.scrollTop > 0) this.showShadowBottom = true;
            else this.showShadowBottom = false;
        },
        onSwipeLeft() {
          if(this.isSidebarActive && this.showCloseButton) this.isSidebarActive = false
        },
        onSwipeRightSidebarSwipeArea() {
          if(!this.isSidebarActive && this.showCloseButton) this.isSidebarActive = true
        },
        canSee(item) {
            this.$acl.check(this.$store.state.userRole);
            if(!item.role) return true

            return this.$acl.check(item.role)
        },
        addStoreMenu(){
            let items = [...this.sidebarItems]

            const is_admin = this.$store.state.auth.userRole == 'admin'

            items.push({
                header: "Dashboard"
            })

            items.push({
                url: {name: 'dashboard-analytics'},
                name: "Operational Dashboard",
                slug: 'dashboard',
                icon: "BarChart2Icon",
                i18n: "Operational Dashboard",
            })

            if (this.$store.state.is_online) {
                if (this.hasAccess('read', 'pm_dashboard', 'all')) {
                    items.push({
                        url: {name: 'dashboard2'},
                        name: "PM Dashboard",
                        slug: 'dashboard2',
                        icon: "BarChart2Icon",
                        i18n: "PM Dashboard",
                    })
                }

                if (is_admin) {
                    items.push({
                        url: {name: 'dashboard3'},
                        name: "Management Dashboard",
                        slug: 'dashboard3',
                        icon: "BarChart2Icon",
                        i18n: "Management Dashboard",
                    })
                }

                if (this.hasAccess('read', 'status_dashboard', 'all')) {
                    items.push({
                        url: {name: 'status-dashboard'},
                        name: "Status Dashboard",
                        slug: 'status-dashboard',
                        icon: "BarChart2Icon",
                        i18n: "Status Dashboard",
                    })
                }
            }

            let h;

            h = {
                header: "Highway Maintenance"
            }

            items.push(h)

            //////////////////////////
            // Routine MAINTENANCE
            /////////////////////////
            let routine_maintenance = {
                url: '#',
                name: "Routine Maintenance Issues",
                icon: require('@/assets/images/icons/routine.png'),
                icon_light: require('@/assets/images/icons/incident_light.png'),
                icon_type: 'image',
                submenu: []
            }

            if (this.hasAccess('create', `issue_routine_maintenance`, 'all')) {
                routine_maintenance.submenu.push({
                    url: {name: 'issues-new', params: {issue_type: 'routine_maintenance'}},
                    name: "Create Issue",
                    slug: 'issues-new',
                    icon: "PlusIcon",
                    i18n: "Create Issue",
                })
            }

            if ((this.hasAccess('read', `issue_routine_maintenance`, 'any') || this.hasAccess('read_resolution', `issue_routine_maintenance`, ['all', 'assigned'])
                || this.hasAccess('read_external_resolution', `issue_routine_maintenance`, ['all', 'assigned']))
            ) {
                routine_maintenance.submenu.push({
                    url: {name: 'issues-list', params: {issue_type: 'routine_maintenance'}},
                    name: "View Issues",
                    slug: 'issues-list',
                    icon: "ChevronRightIcon",
                    i18n: "View Issues",
                })
            }

            // if status is online then only showing module
            if (this.$store.state.is_online) {
                let rm_reports = this.$store.state.organisation.dpr_reports.filter(report => report.issue_type == 'routine_maintenance')

                /////////////////////////////////
                // Routine MAINTENANCE DPR Month
                /////////////////////////////////
                if (this.hasAccess('read', `dpr_log_month`, 'all'))
                    rm_reports.forEach(
                        report => {
                            routine_maintenance.submenu.push({
                                url: {name: 'dpr-report-view', params: {issue_type: 'routine_maintenance', report_id: report.id}},
                                name: report.name,
                                slug: 'dpr-view-' + report.id,
                                icon: "ChevronRightIcon",
                                i18n: report.name,
                            })
                        }
                    )

                /////////////////////////////////////
                // Routine MAINTENANCE DPR Daily Log
                /////////////////////////////////////
                if (rm_reports.length && this.hasAccess('read', `dpr_log_daily`, 'all')) {
                    routine_maintenance.submenu.push({
                        url: {name: 'dpr-report-transaction', params: {issue_type: 'routine_maintenance'}},
                        name: "DPR Daily Logs",
                        slug: 'dpr-report-transaction',
                        icon: "ChevronRightIcon",
                        i18n: "DPR Daily Logs",
                    })
                }
            }

            if (routine_maintenance.submenu.length) {
                items.push(routine_maintenance)
            }

            //////////////////////////
            // Electrical MAINTENANCE
            /////////////////////////
            let electrical_maintenance = {
                url: '#',
                name: "Electrical Maintenance Issues",
                icon: require('@/assets/images/icons/electrical.png'),
                icon_light: require('@/assets/images/icons/incident_light.png'),
                icon_type: 'image',
                submenu: []
            }

            if (this.hasAccess('create', `issue_electrical_maintenance`, 'all')) {
                electrical_maintenance.submenu.push({
                    url: {name: 'issues-new', params: {issue_type: 'electrical_maintenance'}},
                    name: "Create Issue",
                    slug: 'issues-new',
                    icon: "PlusIcon",
                    i18n: "Create Issue",
                })
            }

            if((this.hasAccess('read', `issue_electrical_maintenance`, 'any') || this.hasAccess('read_resolution', `issue_electrical_maintenance`, ['all', 'assigned'])
                || this.hasAccess('read_external_resolution', `issue_electrical_maintenance`, ['all', 'assigned']))
            ) {
                electrical_maintenance.submenu.push({
                    url: {name: 'issues-list', params: {issue_type: 'electrical_maintenance'}},
                    name: "View Issues",
                    slug: 'issues-list',
                    icon: "ChevronRightIcon",
                    i18n: "View Issues",
                })
            }

            if (electrical_maintenance.submenu.length) {
                items.push(electrical_maintenance)
            }

            //////////////////////////
            // Master Year
            /////////////////////////


            //////////////////////////
            // Major MAINTENANCE
            /////////////////////////
            if (this.hasAccess('read', 'issue_major_maintenance', 'any') || 
                this.hasAccess('read', 'purchase_order', 'any') || 
                this.hasAccess('read', 'drp_transaction', 'any')) {
                let major_maintenance = {
                    url: '#',
                    name: "Major Maintenance Issues",
                    icon: require('@/assets/images/icons/major.png'),
                    icon_light: require('@/assets/images/icons/incident_light.png'),
                    icon_type: 'image',
                    submenu: []
                }

               

                // Move Master Year inside Major Maintenance
                let master_year = {
                    url: '#',
                    name: "Master Year",
                    icon: "CalendarIcon",
                    i18n: "Master Year",
                    submenu: [
                        {
                            url: {name: 'master-year'},
                            name: "Financial Master Year",
                            slug: 'master-year',
                            icon: "ChevronRightIcon",
                            i18n: "Financial Master Year"
                        },
                        {
                            url: {name: 'master-item-group'},
                            name: "Item Group",
                            slug: 'master-item-group',
                            icon: "ChevronRightIcon",
                            i18n: "Item Group"
                        },
                        {
                            url: {name: 'master-item-sub-group'},
                            name: "Item Sub Group",
                            slug: 'master-item-sub-group',
                            icon: "ChevronRightIcon",
                            i18n: "Item Sub Group"
                        },
                        {
                            url: {name: 'master-uom'},
                            name: "Unit of Measurement",
                            slug: 'master-uom',
                            icon: "ChevronRightIcon",
                            i18n: "Unit of Measurement"
                        },
                        {
                            url: {name: 'master-lane'},
                            name: "Lane",
                            slug: 'master-lane',
                            icon: "ChevronRightIcon",
                            i18n: "Lane"
                        },
                        {
                            url: {name: 'master-side'},
                            name: "Side",
                            slug: 'master-side',
                            icon: "ChevronRightIcon",
                            i18n: "Side"
                        },
                        {
                            url: {name: 'master-vendor'},
                            name: "Vendor",
                            slug: 'master-vendor',
                            icon: "ChevronRightIcon",
                            i18n: "Vendor"
                        },
                        {
                            url: {name: 'budget-master'},
                            name: "Budget Master",
                            slug: 'budget-master',
                            icon: "ChevronRightIcon",
                            i18n: "Budget Master"
                        }
                    ]
                }
                if (is_admin || this.hasAccess('read', 'master_year', 'any')) {
                    major_maintenance.submenu.push(master_year)
                }

                if (this.hasAccess('read', 'purchase_order', 'any')) {
                    major_maintenance.submenu.push({
                        url: {name: 'purchase-order'},
                        name: "Purchase Order",
                        slug: 'purchase-order',
                        icon: "ChevronRightIcon",
                        i18n: "Purchase Order",
                    })
                }

                if (this.hasAccess('read', 'drp_transaction', 'any')) {
                    major_maintenance.submenu.push({
                        url: {name: 'drp-transaction'},
                        name: "DRP Transaction",
                        slug: 'drp-transaction',
                        icon: "ChevronRightIcon",
                        i18n: "DRP Transaction",
                    })
                }

                items.push(major_maintenance)
            }

            //////////////////////////
            // Corrective MAINTENANCE
            /////////////////////////
            let corrective_maintenance = {
                url: '#',
                name: "Corrective Maintenance Issues",
                icon: require('@/assets/images/icons/corrective.png'),
                icon_light: require('@/assets/images/icons/highway_light.png'),
                icon_type: 'image',
                submenu: []
            }

            if (this.hasAccess('create', `issue_highway`, 'all')) {
                corrective_maintenance.submenu.push({
                    url: {name: 'issues-new', params: {issue_type: 'highway'}},
                    name: "Create Issue",
                    slug: 'issues-new',
                    icon: "PlusIcon",
                    i18n: "Create Issue",
                })
            }

            if ((this.hasAccess('read', `issue_highway`, 'any') || this.hasAccess('read_resolution', `issue_highway`, ['all', 'assigned'])
                || this.hasAccess('read_external_resolution', `issue_highway`, ['all', 'assigned']))
            ) {
                corrective_maintenance.submenu.push({
                    url: {name: 'issues-list', params: {issue_type: 'highway'}},
                    name: "View Issues",
                    slug: 'issues-list',
                    icon: "ChevronRightIcon",
                    i18n: "View Issues",
                })
            }

            if (corrective_maintenance.submenu.length) {
                items.push(corrective_maintenance)
            }

            ////////////////////
            // Incident Patrol
            ///////////////////
            h = {
                header: "Incident Patrol"
            }

            items.push(h)

            // Road Incident
            let road_incident = {
                url: '#',
                name: "Road Incident",
                icon: require('@/assets/images/icons/road_incident.png'),
                icon_light: require('@/assets/images/icons/incident_light.png'),
                icon_type: 'image',
                submenu: []
            }

            let road_incident_submodule = [
                { label: 'Road User Accidents', code: 'road_user_accident'},
                { label: 'Occupational Accidents', code: 'occupational'},
                { label: 'Hazard Accidents', code: 'hazard'},
                { label: 'Dead Animal Debris Removal Issue', code: 'dead_animal_debris_removal'},
                { label: 'Vehicle Breakdown Issue', code: 'vehicle_breakdown'},
                { label: 'Traffic Violation Issue', code: 'traffic_violation'},
                { label: 'Unauthorised Parking Issue', code: 'unauthorised_parking'},
                { label: 'Unauthorised Access Issue', code: 'unauthorised_access'},
                { label: 'Unauthorised Median Cut Issue', code: 'unauthorised_media_cut'},
                { label: 'Material Damage Issue', code: 'material_damage'},
                { label: 'Other Issue', code: 'other'}
            ]

            road_incident_submodule.forEach(obj => {
                if ((this.hasAccess('read', `issue_${obj.code}`, 'any') || this.hasAccess('read_resolution', `issue_${obj.code}`, ['all', 'assigned'])
                    || this.hasAccess('read_external_resolution', `issue_${obj.code}`, ['all', 'assigned']))
                ) {
                    road_incident.submenu.push({
                        url: {name: 'issues-list', params: {issue_type: obj.code}},
                        name: obj.label,
                        slug: 'issues-list',
                        icon: "ChevronRightIcon",
                        i18n: obj.label,
                    })
                }
            })

            if (road_incident.submenu.length) {
                items.push(road_incident)
            }

            // Enroachment ROW
            let enroachment_row = {
                url: '#',
                name: "Enroachment Row Issues",
                icon: require('@/assets/images/icons/enroachment.png'),
                icon_light: require('@/assets/images/icons/incident_light.png'),
                icon_type: 'image',
                submenu: []
            }

            if (this.hasAccess('create', `issue_enroachment_row`, 'all')) {
                enroachment_row.submenu.push({
                    url: {name: 'issues-new', params: {issue_type: 'enroachment_row'}},
                    name: "Create Issue",
                    slug: 'issues-new',
                    icon: "PlusIcon",
                    i18n: "Create Issue",
                })
            }

            if ((this.hasAccess('read', `issue_enroachment_row`, 'any') || this.hasAccess('read_resolution', `issue_enroachment_row`, ['all', 'assigned'])
                || this.hasAccess('read_external_resolution', `issue_enroachment_row`, ['all', 'assigned']))
            ) {
                enroachment_row.submenu.push({
                    url: {name: 'issues-list', params: {issue_type: 'enroachment_row'}},
                    name: "View Issues",
                    slug: 'issues-list',
                    icon: "ChevronRightIcon",
                    i18n: "View Issues",
                })
            }

            if (enroachment_row.submenu.length) {
                items.push(enroachment_row)
            }

            /////////////////
            // Online Module
            /////////////////
            // if user is online then only showing module
            if (this.$store.state.is_online) {

                // Safety Program
                let safety_program = {
                    url: '#',
                    name: "Safety Program",
                    icon: require('@/assets/images/icons/safety.png'),
                    icon_light: require('@/assets/images/icons/incident_light.png'),
                    icon_type: 'image',
                    submenu: []
                }

                if (this.hasAccess('create', `safety_program`, 'all')) {
                    safety_program.submenu.push({
                        url: {name: 'safety-program-new'},
                        name: "Create Safety Program",
                        slug: 'safety-program-new',
                        icon: "PlusIcon",
                        i18n: "Create Safety Program",
                    })
                }

                if ((this.hasAccess('read', `safety_program`, 'any') || this.hasAccess('read_resolution', `safety_program`, ['all', 'assigned'])
                    || this.hasAccess('read_external_resolution', `safety_program`, ['all', 'assigned']))
                ) {
                    safety_program.submenu.push({
                        url: {name: 'safety-program-list'},
                        name: "View Safety Program",
                        slug: 'safety-program-list',
                        icon: "ChevronRightIcon",
                        i18n: "View Safety Program",
                    })
                }

                if (safety_program.submenu.length) {
                    items.push(safety_program)
                }

                // Asset Register
                let asset_register_header = {
                    header: "Asset Register"
                }

                let asset_register = {
                    url: '#',
                    name: "Asset Register",
                    icon: require('@/assets/images/icons/asset.png'),
                    icon_light: require('@/assets/images/icons/asset_light.png'),
                    icon_type: 'image',
                    submenu: []
                }

                if(this.hasAccess('create', `asset_register`, 'all')) {
                    asset_register.submenu.push({
                        url: {name: 'asset-register-new'},
                        name: "Add New",
                        slug: 'asset-register-new',
                        icon: "PlusIcon",
                        i18n: "Add New",
                    })
                }

                if(this.hasAccess('read', `asset_register`, ['all', 'own'])) {
                    asset_register.submenu.push({
                        url: {name: 'asset-register-list'},
                        name: "Browse",
                        slug: 'asset-register-list',
                        icon: "ChevronRightIcon",
                        i18n: "Browse",
                    })
                }

                if (asset_register.submenu.length) {
                    items.push(asset_register_header)
                    items.push(asset_register)
                }

                // Stock Register
                let stock_register_header = {
                    header: "Stock Register"
                }

                let stock_register = {
                    url: '#',
                    name: "Stock Register",
                    icon: require('@/assets/images/icons/stock_register.png'),
                    icon_type: 'image',
                    submenu: []
                }

                let stock_register_submodule = [
                    {label: "Create Stock", slug: 'stock-new', icon: 'PlusIcon', code: 'stock', action: 'create'},
                    {label: "Browse Stock", slug: 'stock-list', icon: 'ChevronRightIcon', code: 'stock', action: 'read'},
                    {label: "Add/Remove Stock", slug: 'stock-log-new', icon: 'PlusIcon', code: 'stock_log', action: 'create'},
                    {label: "Stock Logs", slug: 'stock-log-list', icon: 'ChevronRightIcon', code: 'stock_log', action: 'read'},
                ]

                stock_register_submodule.forEach(obj => {
                    if(this.hasAccess(obj.action, obj.code, 'all')) {
                        stock_register.submenu.push({
                            url: {name: obj.slug},
                            name: obj.label,
                            slug: obj.slug,
                            icon: obj.icon,
                            i18n: obj.label,
                        })
                    }
                })

                if (stock_register.submenu.length) {
                    items.push(stock_register_header)
                    items.push(stock_register)
                }

                //////////////////
                //Reports Section
                /////////////////
                h = {
                    header: "Reports"
                }

                items.push(h)

                let issue_report_array = [
                    {label: 'Issues Reports', slug: 'issues-reports', icon: 'AlertTriangleIcon'},
                    {label: 'Safety Program Reports', slug: 'safety-program-reports', icon: 'PocketIcon'},
                    {label: 'DPR Reports', slug: 'dpr-reports', icon: 'ColumnsIcon'},
                    {label: 'Strip Chart', slug: 'strip-chart', icon: 'LayersIcon'},
                    {label: 'Budget vs Actual', slug: 'budget-actual-report', icon: 'BarChart2Icon'},
                    {label: 'Exports', slug: 'reports-download', icon: 'DownloadCloudIcon'}
                ]

                issue_report_array.forEach(obj=> {
                    h = {
                        url: {name: obj.slug},
                        name: obj.label,
                        slug: obj.slug,
                        icon: obj.icon,
                        i18n: obj.label,
                    }
                    items.push(h)
                })

                ////////////////
                // SAP PO
                ///////////////
                let sap_header = {
                    header: "SAP"
                }

                items.push(sap_header)
                
                let sap_po = {
                    url: '#',
                    name: "PO",
                    icon: require('@/assets/images/icons/spv.png'),
                    icon_light: require('@/assets/images/icons/spv_light.png'),
                    icon_type: 'image',
                    submenu: []
                }

                sap_po.submenu.push({
                    url: {name: 'sap-po-create'},
                    name: "Add PO",
                    slug: 'sap-po-create',
                    icon: "PlusIcon",
                    i18n: "Add PO",
                })

                sap_po.submenu.push({
                    url: {name: 'sap-po-list'},
                    name: "Browse PO",
                    slug: 'sap-po-list',
                    icon: "ChevronRightIcon",
                    i18n: "Browse PO",
                })

                items.push(sap_po)

                ////////////////
                // SPV Manager
                ///////////////
                let spv_manager_header = {
                    header: "SPV Manager"
                }

                let spv_manager = {
                    url: '#',
                    name: "SPV Manager",
                    icon: require('@/assets/images/icons/spv.png'),
                    icon_light: require('@/assets/images/icons/spv_light.png'),
                    icon_type: 'image',
                    submenu: []
                }

                if(is_admin || this.hasAccess('create', 'user', 'all')) {
                    spv_manager.submenu.push({
                        url: {name: 'users-create'},
                        name: "Add User",
                        slug: 'users-create',
                        icon: "PlusIcon",
                        i18n: "Add User",
                    })
                }

                if(is_admin || this.hasAccess('read', 'user', 'all')) {
                    spv_manager.submenu.push({
                        url: {name: 'users-list'},
                        name: "Browse Users",
                        slug: 'users-list',
                        icon: "ChevronRightIcon",
                        i18n: "Browse Users",
                    })
                }

                if (spv_manager.submenu.length) {
                    items.push(spv_manager_header)
                    items.push(spv_manager)
                }

                ////////////////
                // Self Service
                ////////////////
                items.push({
                    header: "Self Service"
                })

                items.push({
                    url: {name: 'organisation-chooser', query: {force: true, next: this.$route.fullPath}},
                    name: "Change Organisation",
                    slug: 'organisation-chooser',
                    icon: "RefreshCwIcon",
                    i18n: "Change Organisation",
                })

                // to show only when it is in mobile app.
                if(this.$store.state.is_mobile) {
                    items.push({
                        url: {name: 'synchronization', query: {auto_sync: false}},
                        name: "Sync Offline Data",
                        slug: 'sync-offline-data',
                        icon: "RefreshCwIcon",
                        i18n: "Sync Offline Data",
                    })
                }

              items.push({
                url: {name: 'page-delete'},
                name: "Delete Account",
                slug: 'page-delete',
                icon: "Trash2Icon",
                i18n: "Delete Account",
              })

                items.push({
                    url: {name: 'page-logout'},
                    name: "Logout",
                    slug: 'page-logout',
                    icon: "LogOutIcon",
                    i18n: "Logout",
                })
            }

            this.finalSidebarItems = items
        }
    },
    components: {
        VxSidebarGroup,
        VxSidebarItem,
        VuePerfectScrollbar,
    },
    mounted() {
        this.$nextTick(() => {
            window.addEventListener('resize', this.handleWindowResize);
        });
        this.setSidebarWidth();
        this.addStoreMenu();
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleWindowResize);
    },
}
</script>

<style lang="scss">
@import "@/assets/scss/vuesax/components/vxSidebar.scss"
</style>
